module.exports = __webpack_public_path__ + "static/location-800a0f0c86d642c342079b7e7d12378b.png";